const city = "lagos"

const deliveryPrices = [
  {
    amount: 4300,
    label: "Abraham Adesanya",
    value: "abraham-adesanya",
    city,
  },
  {
    amount: 3500,
    label: "Abule Ado",
    value: "abule-ado",
    city,
  },
  {
    amount: 35000,
    label: "Abule Egba",
    value: "abule-egba",
    city,
  },
  {
    amount: 9000,
    label: "Agbara",
    value: "agbara",
    city,
  },
  {
    amount: 2500,
    label: "Agege",
    value: "agege",
    city,
  },
  {
    amount: 4300,
    label: "Agungi",
    value: "agungi",
    city,
  },
  {
    amount: 4300,
    label: "Ajah",
    value: "ajah",
    city,
  },
  {
    amount: 3700,
    label: "Alaba",
    value: "alaba",
    city,
  },
  {
    amount: 5000,
    label: "Alagbado",
    value: "alagbado",
    city,
  },
  {
    amount: 3700,
    label: "Alakuko",
    value: "alakuko",
    city,
  },
  {
    amount: 5000,
    label: "Alimosho",
    value: "alimosho",
    city,
  },
  {
    amount: 4300,
    label: "Apapa",
    value: "apapa",
    city,
  },
  {
    amount: 7000,
    label: "Awoyaya",
    value: "awoyaya",
    city,
  },
  {
    amount: 10500,
    label: "Badagry",
    value: "badagry",
    city,
  },
  {
    amount: 4300,
    label: "Badore",
    value: "badore",
    city,
  },
  {
    amount: 4300,
    label: "Chevron",
    value: "chevron",
    city,
  },
  {
    amount: 10500,
    label: "Dangote Refinery",
    value: "dangote-refinery",
    city,
  },
  {
    amount: 4000,
    label: "Egbeda",
    value: "egbeda",
    city,
  },
  {
    amount: 3700,
    label: "Ejigbo",
    value: "ejigbo",
    city,
  },
  {
    amount: 4300,
    label: "Elegushi",
    value: "elegushi",
    city,
  },
  {
    amount: 4500,
    label: "Eleko",
    value: "eleko",
    city,
  },
  {
    amount: 15000,
    label: "Epe",
    value: "epe",
    city,
  },
  {
    amount: 4300,
    label: "Festac",
    value: "festac",
    city,
  },
  {
    amount: 3700,
    label: "Gbagada",
    value: "gbagada",
    city,
  },
  {
    amount: 9000,
    label: "Ibafo",
    value: "ibafo",
    city,
  },
  {
    amount: 11300,
    label: "Ibeju Lekki",
    value: "ibeju-lekki",
    city,
  },
  {
    amount: 3700,
    label: "Idimu",
    value: "idimu",
    city,
  },
  {
    amount: 3700,
    label: "Igando",
    value: "igando",
    city,
  },
  {
    amount: 2500,
    label: "Iju",
    value: "iju",
    city,
  },
  {
    amount: 2500,
    label: "Ikeja",
    value: "ikeja",
    city,
  },
  {
    amount: 4300,
    label: "Ikorodu",
    value: "ikorodu",
    city,
  },
  {
    amount: 4300,
    label: "Ikota",
    value: "ikota",
    city,
  },
  {
    amount: 6000,
    label: "Ikotun",
    value: "ikotun",
    city,
  },
  {
    amount: 4300,
    label: "Ikoyi",
    value: "ikoyi",
    city,
  },
  {
    amount: 4000,
    label: "Ilupeju",
    value: "ilupeju",
    city,
  },
  {
    amount: 3700,
    label: "Ipaja",
    value: "ipaja",
    city,
  },
  {
    amount: 3000,
    label: "Ishaga",
    value: "ishaga",
    city,
  },
  {
    amount: 3700,
    label: "Isolo",
    value: "isolo",
    city,
  },
  {
    amount: 4300,
    label: "Jakande",
    value: "jakande",
    city,
  },
  {
    amount: 5000,
    label: "Jibowu",
    value: "jibowu",
    city,
  },
  {
    amount: 2500,
    label: "Ketu",
    value: "ketu",
    city,
  },
  {
    amount: 4300,
    label: "Lagos Island",
    value: "lagos-island",
    city,
  },
  {
    amount: 4300,
    label: "Lekki Phase 1",
    value: "lekki-phase-1",
    city,
  },
  {
    amount: 2500,
    label: "Magodo",
    value: "magodo",
    city,
  },
  {
    amount: 3800,
    label: "Marina",
    value: "marina",
    city,
  },
  {
    amount: 2500,
    label: "Maryland",
    value: "maryland",
    city,
  },
  {
    amount: 9000,
    label: "Mowe",
    value: "mowe",
    city,
  },
  {
    amount: 2500,
    label: "Ogba",
    value: "ogba",
    city,
  },
  {
    amount: 2500,
    label: "Ogudu",
    value: "ogudu",
    city,
  },
  {
    amount: 7000,
    label: "Ojo",
    value: "ojo",
    city,
  },
  {
    amount: 2500,
    label: "Ojodu",
    value: "ojodu",
    city,
  },
  {
    amount: 4300,
    label: "Okota",
    value: "okota",
    city,
  },
  {
    amount: 2500,
    label: "Omole",
    value: "omole",
    city,
  },
  {
    amount: 4000,
    label: "Oshodi",
    value: "oshodi",
    city,
  },
  {
    amount: 4000,
    label: "Palmgroove",
    value: "palmgroove",
    city,
  },
  {
    amount: 9000,
    label: "Redeemed Camp",
    value: "redeemed-camp",
    city,
  },
  {
    amount: 5500,
    label: "Sango Ota",
    value: "sango-ota",
    city,
  },
  {
    amount: 6000,
    label: "Sangotedo",
    value: "sangotedo",
    city,
  },
  {
    amount: 4300,
    label: "Sattelite Town",
    value: "sattelite-town",
    city,
  },
  {
    amount: 4000,
    label: "Surulere",
    value: "surulere",
    city,
  },
  {
    amount: 4300,
    label: "Trade Fair",
    value: "trade-fair",
    city,
  },
  {
    amount: 4300,
    label: "VGC",
    value: "vgc",
    city,
  },
  {
    amount: 3800,
    label: "Victoria Island",
    value: "victoria-island",
    city,
  },
  {
    amount: 5000,
    label: "Yaba",
    value: "yaba",
    city,
  },
  {
    amount: 17500,
    label: "Intercity / Outside Lagos",
    value: "intercity",
    city,
  },
  {
    amount: 16000,
    label: "Other",
    value: "other",
    city,
  },
]

module.exports = deliveryPrices
